import 'meyer-reset-scss';
import React, { Component } from 'react';
import { newTag, newGovoltePlugin, newPageTracker } from '@npotag/tag';
import * as Sentry from "@sentry/react";
import getChannelBrandId from './ChannelBrandId'
import './Miniplayer.scss';
import NowLiveScreen from './NowLiveScreen/NowLiveScreen';
import PlaylistScreen from './PlaylistScreen/PlaylistScreen';
import ChannelsScreen from './ChannelsScreen/ChannelsScreen';
import Playerbar from './Playerbar/Playerbar';
import NpoPlayer from './NpoPlayer/NpoPlayer';
import helpers from './helpers';
import config from '../config';

class Miniplayer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            theme: false,
            playerReady: false
        };

        this.setPlayerReady = (value) => {
            this.setState({playerReady: value});
        }

        this.changeThemeEvent = new Event('changeTheme');
        this.getTheme = ({ theme } = this.state) => theme;

        this.changeTheme = newChannel => {
            // Validate new channel
            if (!config[newChannel]) {
                throw new Error(`Channel ${newChannel} does not exist`);
            }

            this.state.theme = newChannel;
            this.setNpoLabels();
            helpers.loadChannelInfo(({ theme } = this.state) => theme);

            return window.dispatchEvent(this.changeThemeEvent);
        };

        this.NPOlabels = {
            page: 'miniplayer',
            chapter_1: 'radioplayer',
            chapter_2: this.getTheme(),
            environment: process.env.NODE_ENV === 'production' ? 'prod' : 'dev',
            platform: 'site',
        };

        this.setNpoLabels = () => {
            this.NPOlabels.chapter_2 = this.getTheme();
            this.NPOlabels.brand_id = getChannelBrandId();

            switch (this.getTheme()) {
                case 'nporadio1':
                    this.NPOlabels.brand = 'nporadio1';
                    break;
                case 'nporadio2':
                case 'nporadio6':
                    this.NPOlabels.brand = 'nporadio2';
                    break;
                case 'npo3fm':
                case 'npo3fmalternative':
                case 'npo3fmkxradio':
                    this.NPOlabels.brand = 'npo3fm';
                    break;
                case 'nporadio4':
                    this.NPOlabels.brand = 'nporadio4';
                    break;
                case 'nporadio5':
                case 'nposterrennl':
                    this.NPOlabels.brand = 'nporadio5';
                    break;
                case 'npofunx':
                case 'npofunxamsterdam':
                case 'npofunxrotterdam':
                case 'npofunxutrecht':
                case 'npofunxdenhaag':
                case 'npofunxdance':
                case 'npofunxslowjamz':
                case 'npofunxarab':
                case 'npofunxhiphop':
                case 'npofunxreggae':
                case 'npofunxlatin':
                    this.NPOlabels.brand = 'npofunx';
                    break;
                case 'npoblend':
                    this.NPOlabels.brand = 'npoblend';
                    break;

                default:
                    break;
            }

            window.NPOlabels = this.NPOlabels;
            try {
                const npoTagInstance = newTag(
                    {
                        brand: window.NPOlabels.brand,
                        brand_id: window.NPOlabels.brand_id,
                        platform: "site",
                        platform_version: "1.0.0",
                    },
                    [newGovoltePlugin()]
                );

                window.NpoTagContext = npoTagInstance.getContext();

                const tracker = newPageTracker(
                    npoTagInstance,
                    window.pageTrackers
                );

                window.tracker = tracker;
            } catch(error) {
                Sentry.captureException(error);
            }
        };

        const path = window.location.pathname.substr(1);
        const pathSplitted = path.split('/');
        const firstSplice = pathSplitted.slice(-1);
        const secondSplice = pathSplitted.slice(-2);
        const lastItemFromPath =
            firstSplice[0] === '' ? secondSplice[0] : firstSplice[0];

        if (
            lastItemFromPath &&
            lastItemFromPath.length &&
            lastItemFromPath !== 'mini-player'
        ) {
            let newChannel = lastItemFromPath;

            // Validate new channel
            if (!config[newChannel]) {
                // If channel is not found, try legacy names
                if (!config[`npo${newChannel}`]) {
                    document.write(
                        `Channel <i>${newChannel}</i> does not exist`
                    );
                } else {
                    newChannel = `npo${newChannel}`;
                }
            }

            this.changeTheme(newChannel);
        } else {
            document.location.replace('radio1');
        }
    }

    render() {
        const { theme, playerReady } = this.state;
        if (!theme) {
            return null;
        }

        return (
            <div className="Miniplayer" data-theme={theme}>
                <NowLiveScreen theme={theme} channel={this.getTheme()} />
                <PlaylistScreen />
                <ChannelsScreen />
                <Playerbar channel={this.getTheme()} playerReady={playerReady} />
                <NpoPlayer channel={this.getTheme()} setPlayerReady={this.setPlayerReady}/>
            </div>
        );
    }
}

export default Miniplayer;
